/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/display-name */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-key */
import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import AppLayout from "layout/AppLayout";
import axios from "axiosClient";
import { toast } from "react-toastify";

const CheckPin = () => {
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);

  const handleValuesChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleLookupPinpp = async () => {
    const pinpp = values.pinpp ? String(values.pinpp).trim() : "";
    const rex = /^\d{14}$/;
    if (!rex.test(pinpp)) {
      toast.warn("Please input a valid 14-digit PINPP");
      return;
    }

    const secret = process.env.REACT_APP_PIN_INFO_SECRET;
    if (!secret) {
      toast.error(
        "Missing PIN info secret. Set REACT_APP_PIN_INFO_SECRET and rebuild.",
      );
      return;
    }

    try {
      setLoading(true);
      const result = await axios.post(
        `/api/pin-info`,
        { pinpp },
        {
          headers: {
            "x-pin-info-secret": secret,
          },
        },
      );
      if (result.status === 200) {
        setValues({
          ...values,
          pinpp: result.data?.pinpp ?? pinpp,
          firstName: result.data?.firstName ?? values.firstName,
          lastName: result.data?.lastName ?? values.lastName,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      if (status === 400) {
        toast.error("Invalid PINPP. Please check and try again.");
      } else if (status === 401) {
        toast.error("PIN info secret is missing/invalid.");
      } else if (status === 502) {
        toast.error(
          "PIN info lookup failed (upstream error). Please try again later.",
        );
      } else {
        toast.error("Failed to lookup PINPP. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppLayout>
      <div className="dashboard-wrapper">
        <Card className="h-100 m-4">
          <CardBody>
            <CardTitle>PINFL List</CardTitle>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                handleLookupPinpp();
              }}
            >
              <Row className="text-left">
                <Col md="3">
                  <FormGroup>
                    <Label>PINPP</Label>
                    <Input
                      type="text"
                      name="pinpp"
                      value={values.pinpp}
                      onChange={(e) => {
                        handleValuesChange(e);
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md="12 d-flex">
                  <Button
                    color="primary"
                    onClick={() => handleLookupPinpp()}
                    className="mr-2"
                    disabled={loading}
                  >
                    Search
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
        {values.firstName && (
          <Card className="mt-2">
            <CardBody>
              <Row>
                <Col md="6">
                  <p>
                    <strong>First Name: </strong> {values.firstName}
                  </p>
                </Col>
                <Col md="6">
                  <p>
                    <strong>Last Name: </strong> {values.lastName}
                  </p>
                </Col>
                <Col md="6">
                  <p>
                    <strong>PINPP: </strong> {values.pinpp}
                  </p>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </div>
    </AppLayout>
  );
};

export default CheckPin;
